module.exports = __webpack_public_path__ + "img/法人区域@2x.cc0034e2.png";